import { GET_HOME_INFO } from '../../constants';

const initialState = {
  error: null,
  items: {},
  loaded: false,
  loading: false,
};

export const getHomeInfoReducer = (
  state = initialState,
  action: { type?: string; result?: any; error?: any } = {},
) => {
  switch (action.type) {
    case `${GET_HOME_INFO}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };

    case `${GET_HOME_INFO}_SUCCESS`:
      return {
        ...state,
        error: null,
        items: action.result || {},
        loaded: true,
        loading: false,
      };

    case `${GET_HOME_INFO}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };

    default:
      return state;
  }
};

export default getHomeInfoReducer;
